import {VideoEventAbstract} from 'app/components/tv/events/VideoEvent';
import Video from 'app/components/tv/models/video';

export default class ChangedContentEvent extends VideoEventAbstract {
  readonly nextVideo?: Video;

  constructor(nextVideo?: Video) {
    super();
    this.nextVideo = nextVideo;
  }
}
